import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 300px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 1rem;

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

export const Placa = styled.div`
  padding: 0;
  width: 400px;
  height: 110px;
  border-radius: 6px;
  border: 4px solid #000000;
  box-shadow: 0px 0px 2px 2px #cccccc;
  display: flex;
  flex-direction: column;

  header {
    margin: 0;
    height: 30px;
    padding: 0 5px;
    background-color: #013194;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    h1 {
      margin-top: 10px;
      display: block;
      text-align: center;
      font-size: 16px;
      color: #f7f7f7;
      font-weight: bold;
    }
    img {
      width: 25px;
      height: 20px;
      z-index: 2;
    }
  }
  footer {
    margin-top: 0;
    height: 70px;
    background-color: #f7f7f7;
    justify-content: center;
    text-align: center;
    position: relative;

    h2 {
      font-size: 64px;
      font-weight: bold;
      color: #050505;
    }
    p {
      line-height: 28px;
      position: absolute;
      top: 72%;
      right: 93%;
      font-weight: bold;
    }
  }

  @media (max-width: 600px) {
    footer > h2 {
      margin-top: 8px;
      font-size: 52px;
    }
    footer p {
      font-size: 13px;
      top: 70%;
      right: 93%;
    }
  }
`;

export const Details = styled.div`
  width: 600px;
  padding: 10px 30px;
  margin: 20px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0px 0px 5px 3px #cccccc;
  border-radius: 5px;

  @media (max-width: 700px) {
    width: 100%;
  }
`;

export const Line = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-bottom: 5px;
  padding: 0;

  label {
    margin: 0;
    padding: 0;
    font-size: 20px;
    font-weight: bold;
  }
  h3 {
    margin-top: 2px;
    padding: 0 10px;
  }
`;

export const Message = styled.h2`
  font-size: 1rem;
  line-height: 1.5rem;
  width: 80%;
  text-align: left;
  font-weight: bold;
  margin-bottom: 1rem;

  @media (max-width: 600px) {
    font-size: 1rem;
  }
`;
